module.exports = __webpack_public_path__ + "static/media/jobOffer1.6abb3601.svg";